import { render, staticRenderFns } from "./trainee.profile.vue?vue&type=template&id=75db2e6a&scoped=true&"
import script from "./trainee.profile.vue?vue&type=script&lang=ts&"
export * from "./trainee.profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db2e6a",
  null
  
)

export default component.exports